<div class="logo-brand-app">
  <div class="logo"></div>
  <div class="app-title" *ngIf="!isCollapsed">MyEcom<span>{{currEnvVer | async}}</span></div>
</div>

<ul nz-menu [nzMode]="isCollapsed ? 'vertical' : 'inline'" class="sidebar-container">
  <ng-container *ngFor='let nav of navList'>
    <ng-container *ngIf='hasChildrenNav(nav); else topMenus'>
      <li nz-submenu [nzOpen]="isCollapsed ? false : nav.isOpen" [nzTitle]="nav.name[currLang] || null"
          [nzIcon]="nav.icon || null">
        <ul>
          <li nz-menu-item *ngFor='let subNav of getChildrenNav(nav.children || [])' [nzSelected]="subNav.isSelected"
              nzMatchRouterExact>
            <span nz-icon *ngIf='!!subNav.icon' [nzType]="subNav.icon"></span>
            <!--<a [routerLink]="subNav.showType && isInSamePath(subNav.path) ? [] : [subNav.path]"
               [queryParams]="subNav.showType ? {module:subNav.code, t: getTimestamp()} : null"
               [queryParamsHandling]="subNav.showType ? 'merge' : null">{{subNav.name[currLang]}}</a>-->
            <a (click)="navMenuClick(subNav)">{{subNav.name[currLang]}}</a>
          </li>
        </ul>
      </li>
    </ng-container>
    <ng-template #topMenus>
      <li nz-menu-item nzMatchRouterExact [nzSelected]="nav.isSelected" *ngIf='nav.type === rescType.ROUTE'>
        <span nz-icon *ngIf='!!nav.icon' [nzType]="nav.icon"></span>
        <!--<a [routerLink]="[nav.path]"
           [state]="{attrCfg: getChildrenAttrCfg(nav)}">{{nav.name[currLang]}}</a>-->
        <a (click)="navMenuClick(nav)" nz-tooltip [nzTooltipTitle]="nav.name[currLang] || null">{{nav.name[currLang]}}</a>
      </li>
    </ng-template>
  </ng-container>
</ul>

<div class="sidebar-bottom center">
  <ng-container *ngIf="!isCollapsed">
    <app-user-profile></app-user-profile>
    <app-theme-change></app-theme-change>
  </ng-container>
  <i class="trigger center" nz-icon [nzType]="isCollapsed ? 'double-right' : 'double-left'" (click)="collapsedEvt.emit()"></i>
</div>
